import { put } from "redux-saga/effects";
import { message } from "antd";

import ActivityApiCaller from "../../config/api/activityapicaller";

import { InterestAction } from "../actions";

export default class InterestMiddleware {
  static *getInterests({ payload, cb }) {
    try {
      const action =
        payload?.filter === "My Interests"
          ? "sender"
          : payload?.filter === "Interested in Me"
          ? "receiver/accepted"
          : "receiver/pending";

      const res = yield ActivityApiCaller.Get(
        `/activity/interest/${action}?sort=${payload.sort ?? ""}`
      );

      if (res?.status === 200) {
        yield put(InterestAction.getInterestsSuccess(res?.data?.data));
      } else {
        yield put(InterestAction.getInterestsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(InterestAction.getInterestsFailure());
    }
  }
  static *getInterestsAll({ cb }) {
    try {
      const res = yield ActivityApiCaller.Get(`/activity/interest/all`);
      if (res?.status === 200) {
        yield put(InterestAction.getInterestsAllSuccess(res?.data?.data));
      } else {
        yield put(InterestAction.getInterestsAllFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(InterestAction.getInterestsAllFailure());
    }
  }
  static *sendInterest({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Post("/activity/interest", payload);

      if (res.status === 200) {
        message.success(res.data.message);
        yield put(InterestAction.sendInterestSuccess(res.data.data));
        yield put(InterestAction.getInterests({ filter: "My Interests" }));
        yield put(InterestAction.getInterestsAll());
      } else {
        message.error(res.data.message);
        yield put(InterestAction.sendInterestFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(InterestAction.sendInterestFailure());
    }
  }

  static *updateInterest({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Put("/activity/interest", payload);

      if (res.status === 200) {
        message.success(res?.data?.message);
        yield put(InterestAction.updateInterestSuccess(res.data.Data));
      } else {
        message.error(res?.data?.message);
        yield put(InterestAction.updateInterestFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(InterestAction.updateInterestFailure());
    }
  }
}
